<template>
    <iframe
    v-if="src"
    title="privacy"
    :src="src"
    frameborder="0"
    style="width: 100%; height: 100vh;"
  ></iframe>
</template>

<script>
import { getTenantBaseConfig } from "@/domainMapping";
const packageJson = require("../../../package.json");
export default {
  name: 'SalesRules',
  components: {

  },
  data () {
    return {
      src: '',
    }
  },
  created () {
    this.src = `/${packageJson.name}/privacy-tenant${getTenantBaseConfig().brandId}.html`;
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

</style>
